<template>
  <div
    class="mt-3 bb-log-table"
    id="board"
  >
    <vue-good-table
      :columns="headings"
      :fixed-header="false"
      :rows="logs"
      :pagination-options="{
        enabled: true,
        mode: 'records',
        perPage: 30,
        position: 'bottom',
        dropdownAllowAll: true,
        setCurrentPage: 1,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'Logs per page',
        ofLabel: 'of',
        allLabel: 'All',
      }"
      :row-style-class="rowStyleClassFn"
      styleClass="vgt-table bordered"
      theme="black-rhino"
    >
      <template v-slot:table-row="props">
        <span>{{ formatCellValue(props) }}</span>
      </template>
      <template #emptystate>No logs for campaign</template>
    </vue-good-table>
  </div>
</template>

<script>
import 'vue-good-table-next/dist/vue-good-table-next.css'
import { VueGoodTable } from 'vue-good-table-next'

export default {
  name: 'TableLogsComponent',
  //==================================================================
  // components
  //------------
  components: {
    VueGoodTable,
  },
  //==================================================================
  // props
  //-------
  props: {
    headings: {
      type: Array,
      required: true,
    },
    logs: {
      type: Array,
      required: true,
    },
  },
  //====================================================================
  // methods
  //---------
  methods: {
    formatCellValue(props) {
      if (
        props.column.field === 'type' &&
        props.formattedRow.type === 'Notification'
      ) {
        return 'Event'
      }

      return props.formattedRow[props.column.field]
    },
    //==================================================================
    // colour rows
    //-------------
    rowStyleClassFn(row) {
      if (row?.type === 'Character') {
        return 'rowSheet'
      }

      if (row?.type === 'Combat') {
        return 'rowParty'
      }

      return 'rowNeutral'
    },
  },
}
</script>

<style>
.bb-log-table .vgt-table tbody td,
.bb-log-table .vgt-table tbody td > * {
  padding-top: 0.3em !important;
  padding-bottom: 0.3em !important;
  line-height: 1.15;
}

.vgt-table th.bb-log-timestamp,
.vgt-table td.bb-log-timestamp,
.vgt-table td.bb-log-timestamp > * {
  min-width: 210px !important;
  width: 210px !important;
  white-space: nowrap !important;
}
</style>
